import { useState } from 'react'

type PasswordInputProps = {
  id: string
  accessibleName: string
  value: string
  onChange: (value: string) => void
  autoComplete: string
  minLength?: number
  maxLength?: number
  inputStyle?: React.CSSProperties
}

export default function PasswordInput({
  id,
  accessibleName,
  value,
  onChange,
  autoComplete,
  minLength,
  maxLength,
  inputStyle,
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false)
  const visibilityAction = visible ? 'Hide' : 'Show'

  return (
    <div style={wrapperStyle}>
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        autoComplete={autoComplete}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        minLength={minLength}
        maxLength={maxLength}
        required
        style={{ ...baseInputStyle, ...inputStyle, paddingRight: 42 }}
      />
      <button
        type="button"
        aria-label={`${visibilityAction} ${accessibleName}`}
        aria-pressed={visible}
        title={`${visibilityAction} ${accessibleName}`}
        onClick={() => setVisible((current) => !current)}
        style={visibilityButtonStyle}
      >
        <EyeIcon crossed={visible} />
      </button>
    </div>
  )
}

function EyeIcon({ crossed }: { crossed: boolean }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
      <circle cx="12" cy="12" r="3" />
      {crossed && <path d="m4 4 16 16" />}
    </svg>
  )
}

const wrapperStyle: React.CSSProperties = { position: 'relative' }
const baseInputStyle: React.CSSProperties = {
  boxSizing: 'border-box',
  width: '100%',
  padding: '8px 10px',
  border: '1px solid #ccc',
  borderRadius: 4,
  fontSize: 14,
  fontFamily: 'inherit',
}
const visibilityButtonStyle: React.CSSProperties = {
  position: 'absolute',
  top: '50%',
  right: 7,
  width: 30,
  height: 30,
  padding: 0,
  transform: 'translateY(-50%)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  borderRadius: 4,
  background: 'transparent',
  color: '#666',
  cursor: 'pointer',
}
